<template>
    <div class="w-100 p-1 d-flex justify-content-center align-items-center bg-primary">
        <p class="font-weight-bold text-white" v-if="subscription.days_till_account_lock > 0">
            Uh-Oh! We were unable to process your payment. Your account will remain active for
            <u>{{ subscription.days_till_account_lock }}</u> more day(s) before locking out.
        </p>
        <p class="font-weight-bold text-white" v-else>
            Your account has been locked due to failed charge attempts. Please check your payment
            settings and update your information.
        </p>
    </div>
</template>

<script>
export default {
    name: "FailedChargeWidget",
    props: ["subscription"],
};
</script>
